import { render, staticRenderFns } from "./HomeDoc.vue?vue&type=template&id=0cf215aa"
import script from "./HomeDoc.vue?vue&type=script&lang=js"
export * from "./HomeDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports